module.exports = __webpack_public_path__ + "static/media/cottage.b23cf629.jpg";